module.exports = __webpack_public_path__ + "img/heart-exclamation.c5a76d98.png";